import React, { useState, useEffect } from 'react';
import { doc, getDoc, setDoc, updateDoc, deleteField } from 'firebase/firestore/lite';
import { Converter } from 'opencc-js';
const t2s = Converter({ from: 'tw', to: 'cn' });






// ===== 編號排序工具 (與主畫面一致) =====
const parseBianHao = (val) => {
  const s = (val ?? '').toString().trim().toLowerCase();
  const m = s.match(/^(\d+)([a-z]?)$/);
  if (!m) return { num: Number.NaN, suffix: '', raw: s };
  return { num: parseInt(m[1], 10), suffix: m[2] || '', raw: s };
};

const compareBianHaoRaw = (va, vb, dir = 'asc') => {
  const a = parseBianHao(va);
  const b = parseBianHao(vb);

  if (Number.isNaN(a.num) && Number.isNaN(b.num)) {
    const cmp0 = (a.raw || '').localeCompare(b.raw || '', undefined, { numeric: true, sensitivity: 'base' });
    return dir === 'asc' ? cmp0 : -cmp0;
  }
  if (Number.isNaN(a.num)) return dir === 'asc' ? 1 : -1;
  if (Number.isNaN(b.num)) return dir === 'asc' ? -1 : 1;

  if (a.num !== b.num) return dir === 'asc' ? a.num - b.num : b.num - a.num;

  const aBase = a.suffix === '';
  const bBase = b.suffix === '';
  if (aBase !== bBase) return dir === 'asc' ? (aBase ? -1 : 1) : (aBase ? 1 : -1);

  const cmp = a.suffix.localeCompare(b.suffix, undefined, { sensitivity: 'base' });
  return dir === 'asc' ? cmp : -cmp;
};
// ====================================

const CustomPlaylistEditor = ({ 
  auth, 
  firestore, 
  setIsCustomPlaylistOpen, 
  displayLanguage, 
  originalHymnList, 
  customPlaylistNames, 
  setCustomPlaylistNames, 
  youtubePlaylists, 
  setYoutubePlaylists, 
  customPlaylistsSongs, 
  setCustomPlaylistsSongs, 
  coverSongMode: parentCoverSongMode,           // ✅ 從父組件接收
  setCoverSongMode: parentSetCoverSongMode,     // ✅ 從父組件接收
  originalHymnListCopy,                          // ✅ 從父組件接收
  onDisplayLanguageChange,                       // 🔴 從父組件接收：語言模式變更函數
  onSaveSuccess 
}) => {
  const [customPlaylist, setCustomPlaylist] = useState([[], [], [], [], []]);
  const [selectedCustomPlaylistIndex, setSelectedCustomPlaylistIndex] = useState(-1); // ✅ 改為 -1，不點亮任何歌單
  const [sortedHymnList, setSortedHymnList] = useState([]);
  const [checkedSongs, setCheckedSongs] = useState({});
  const [message, setMessage] = useState('');
  const [clearConfirmIndex, setClearConfirmIndex] = useState(null);  // 🔹 用於確認清除的狀態
  // ✅ 移除重複的 const [youtubePlaylists, setYoutubePlaylists] = useState(...)
  // 改用從 App.js 傳入的 props

  const [searchTerm, setSearchTerm] = useState('');
  const [filteredHymnList, setFilteredHymnList] = useState([]);

  // 排序狀態
  const [sortConfig, setSortConfig] = useState({ key: '编号', direction: 'desc' }); // 初始大到小
  
  // ✅ 使用從父組件傳來的翻唱歌曲模式，若沒有則預設為2
  const [coverSongMode, setCoverSongMode] = useState(parentCoverSongMode || 2);
  const [userCoverLinks, setUserCoverLinks] = useState({}); // {编号: YouTube链接}
  const [isInCoverMode, setIsInCoverMode] = useState(true); // ✅ 新增：追蹤是否在翻唱模式（初始為true）

  // ✅ 同步父組件的 coverSongMode
  useEffect(() => {
    if (parentCoverSongMode) {
      setCoverSongMode(parentCoverSongMode);
    }
  }, [parentCoverSongMode]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const user = auth.currentUser;
    if (user) {
      loadCustomPlaylists(user.uid);
    } else {
      setIsCustomPlaylistOpen(false);
    }
  }, [auth, setIsCustomPlaylistOpen]);

  useEffect(() => {
    if (Array.isArray(originalHymnList)) {
      const sortedOriginal = [...originalHymnList].sort((a, b) => compareBianHaoRaw(a.编号, b.编号, 'desc'));
      setSortedHymnList(sortedOriginal);
      setFilteredHymnList(sortedOriginal);
    }
  }, [originalHymnList]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    updateCheckedSongs();
  }, [customPlaylist, selectedCustomPlaylistIndex, filteredHymnList]);

  const updateCheckedSongs = () => {
    // ✅ 如果沒有選擇歌單（翻唱模式），清空所有勾選
    if (selectedCustomPlaylistIndex === -1) {
      const updatedCheckedSongs = {};
      filteredHymnList.forEach((song) => {
        updatedCheckedSongs[song.编号] = false;
      });
      setCheckedSongs(updatedCheckedSongs);
      return;
    }
    
    const updatedSelectedPlaylist = customPlaylist[selectedCustomPlaylistIndex];
    const updatedCheckedSongs = {};
    filteredHymnList.forEach((song) => {
      updatedCheckedSongs[song.编号] = updatedSelectedPlaylist.includes(song.编号);
    });
    setCheckedSongs(updatedCheckedSongs);
  };

  const loadCustomPlaylists = async (userId) => {
    try {
      const userDocRef = doc(firestore, 'users', userId);
      const userDoc = await getDoc(userDocRef);
      if (userDoc.exists()) {
        const data = userDoc.data();
        if (data.customPlaylists && Array.isArray(data.customPlaylists)) {
          if (Array.isArray(data.youtubePlaylists)) {
            setYoutubePlaylists(data.youtubePlaylists);
          }
          const loadedPlaylists = data.customPlaylists.map((pl) => pl.songs || []);
          const loadedPlaylistNames = data.customPlaylists.map((pl) => pl.name || '');
          setCustomPlaylist(loadedPlaylists);
          setCustomPlaylistNames(loadedPlaylistNames);
        }
        
        // ✅ 載入使用者翻唱連結
        if (data.userCoverLinks && typeof data.userCoverLinks === 'object') {
          setUserCoverLinks(data.userCoverLinks);
        }
      }
    } catch (error) {
      console.error('Error loading custom playlists:', error);
    }
  };

  // ✅ 新增：從各種YouTube URL格式中提取視頻ID
  const extractVideoId = (url) => {
    if (!url || typeof url !== 'string') return '';
    const trimmedUrl = url.trim();
    
    // 如果已經是純ID (11個字符)
    if (/^[a-zA-Z0-9_-]{11}$/.test(trimmedUrl)) {
      return trimmedUrl;
    }
    
    // https://www.youtube.com/watch?v=VIDEO_ID
    const watchMatch = trimmedUrl.match(/[?&]v=([a-zA-Z0-9_-]{11})/);
    if (watchMatch) return watchMatch[1];
    
    // https://youtube.com/shorts/VIDEO_ID
    const shortsMatch = trimmedUrl.match(/\/shorts\/([a-zA-Z0-9_-]{11})/);
    if (shortsMatch) return shortsMatch[1];
    
    // https://youtu.be/VIDEO_ID
    const youtuBeMatch = trimmedUrl.match(/youtu\.be\/([a-zA-Z0-9_-]{11})/);
    if (youtuBeMatch) return youtuBeMatch[1];
    
    return '';
  };

  const handleCustomPlaylistSelection = (index) => {
    // ✅ 只有當之前選擇的是有效歌單時才保存
    if (selectedCustomPlaylistIndex >= 0 && selectedCustomPlaylistIndex < 5) {
      const updatedCustomPlaylist = [...customPlaylist];
      updatedCustomPlaylist[selectedCustomPlaylistIndex] = Object.keys(checkedSongs).filter((songId) => checkedSongs[songId]);
      setCustomPlaylist(updatedCustomPlaylist);
    }
    setSelectedCustomPlaylistIndex(index);
    setIsInCoverMode(false); // ✅ 切換到歌單模式
  };

  // ✅ 新增：處理使用者翻唱連結輸入
  const handleCoverLinkChange = (songId, value) => {
    setUserCoverLinks(prev => ({
      ...prev,
      [songId]: value
    }));
  };

  // ✅ 新增：處理翻唱歌曲模式變更
  // 🔴 語言模式選擇：立即切換畫面語言，並同步儲存到本機與資料庫
  const handleLanguageSelect = (lang) => {
    if (onDisplayLanguageChange) {
      onDisplayLanguageChange(lang);
    }
  };

  const handleCoverModeChange = (mode) => {
    setCoverSongMode(mode);
    setIsInCoverMode(true); // ✅ 切換到翻唱模式
    setSelectedCustomPlaylistIndex(-1); // ✅ 取消歌單選擇
    // 立即同步到父組件
    if (parentSetCoverSongMode) {
      parentSetCoverSongMode(mode);
    }
  };

  const handleCustomPlaylistNameChange = (event, index) => {
    const updatedNames = [...customPlaylistNames];
    updatedNames[index] = event.target.value;
    setCustomPlaylistNames(updatedNames);
  };

  const handleToggleSong = (songId) => {
    const updatedCheckedSongs = { ...checkedSongs };
    updatedCheckedSongs[songId] = !updatedCheckedSongs[songId];

    const updatedCustomPlaylist = [...customPlaylist];
    const selectedPlaylist = updatedCustomPlaylist[selectedCustomPlaylistIndex];

    if (updatedCheckedSongs[songId]) {
      if (!selectedPlaylist.includes(songId)) selectedPlaylist.push(songId);
    } else {
      const songIndex = selectedPlaylist.indexOf(songId);
      if (songIndex !== -1) selectedPlaylist.splice(songIndex, 1);
    }
    updatedCustomPlaylist[selectedCustomPlaylistIndex] = selectedPlaylist;

    setCheckedSongs(updatedCheckedSongs);
    setCustomPlaylist(updatedCustomPlaylist);
  };

  const handleSaveCustomPlaylist = async () => {
    const user = auth.currentUser;
    if (!user) return;

    try {
      const formatted = customPlaylist.map((playlist, index) => ({
        name: customPlaylistNames[index],
        songs: playlist,
      }));
      
      // ✅ 保存翻唱歌曲模式和使用者翻唱連結
      const dataToSave = { 
        customPlaylists: formatted, 
        youtubePlaylists,
        coverSongMode: coverSongMode,  // 保存翻唱歌曲模式
      };
      
      // ✅ 修正：正確處理被清空的連結
      // userCoverLinks state 裡：有值 = 保留，空字串 = 代表使用者清空了（要從 Firestore 刪除）
      const validCoverLinks = {};
      const keysToDelete = {}; // 需要從 Firestore 刪除的 key
      
      Object.keys(userCoverLinks).forEach(key => {
        const link = (userCoverLinks[key] || '').toString().trim();
        if (!link) {
          // 空的 → 標記為要刪除（用 deleteField()）
          keysToDelete[`userCoverLinks.${key}`] = deleteField();
          return;
        }
        // 有值 → 整理後保留
        if (link.includes('youtube.com') || link.includes('youtu.be')) {
          const videoId = extractVideoId(link);
          validCoverLinks[key] = videoId || link;
        } else {
          validCoverLinks[key] = link;
        }
      });
      dataToSave.userCoverLinks = validCoverLinks;
      
      const userDocRef = doc(firestore, 'users', user.uid);
      // 第一步：保存所有欄位（含有值的 userCoverLinks）
      await setDoc(userDocRef, dataToSave, { merge: true });
      
      // 第二步：如果有被清空的連結，用 updateDoc 搭配 deleteField() 從 Firestore 移除
      if (Object.keys(keysToDelete).length > 0) {
        await updateDoc(userDocRef, keysToDelete);
      }
      
      // ✅ 保存後同步更新本地 state（只保留有值的）
      setUserCoverLinks(validCoverLinks);
      
      // ✅ 同時更新父組件的狀態
      if (setYoutubePlaylists) {
        setYoutubePlaylists([...youtubePlaylists]);
      }
      
      // ✅ 更新父組件的翻唱歌曲模式
      if (parentSetCoverSongMode) {
        parentSetCoverSongMode(coverSongMode);
      }
      
      // ✅ 新增：同時更新父組件的 customPlaylistsSongs 狀態
      if (setCustomPlaylistsSongs) {
        setCustomPlaylistsSongs([...customPlaylist]);
      }
      
      // ✅ 新增：通知父組件重新載入使用者翻唱連結
      if (onSaveSuccess) {
        onSaveSuccess();
      }
      
      const successMsg = displayLanguage === '简体' ? '歌单保存成功' : displayLanguage === '繁體' ? '歌單保存成功' : 'Playlist saved successfully';
      setMessage(successMsg);
      setTimeout(() => setMessage(''), 4000);
    } catch (error) {
      setMessage(displayLanguage === '简体' ? '歌单保存失败' : displayLanguage === '繁體' ? '歌單保存失敗' : 'Failed to save playlist');
      console.error('Error saving playlist:', error);
    }
  };

  // 🔹 清除特定歌單的函數
  const handleClearPlaylist = (index) => {
    const updatedCustomPlaylist = [...customPlaylist];
    updatedCustomPlaylist[index] = [];
    setCustomPlaylist(updatedCustomPlaylist);
    setClearConfirmIndex(null);
    const clearMsg = displayLanguage === '简体' ? `自选歌单${index + 1}已清除` : displayLanguage === '繁體' ? `自選歌單${index + 1}已清除` : `Custom Playlist ${index + 1} cleared`;
    setMessage(clearMsg);
    setTimeout(() => setMessage(''), 4000);
  };

  // 🔹 獲取清除按鈕的提示文字
  const getClearButtonTitle = (index) => {
    if (displayLanguage === '简体') {
      return `清除全部自选歌单${index + 1}`;
    } else if (displayLanguage === '繁體') {
      return `清除全部自選歌單${index + 1}`;
    } else {
      return `Clear all songs in Custom Playlist ${index + 1}`;
    }
  };

  
// 搜尋
const handleSearch = () => {
  const term = searchTerm.trim();
  if (term === '') {
    setFilteredHymnList([...sortedHymnList]);
    return;
  }

  // 🔹 先把輸入當作繁體 → 轉成簡體
  const simplifiedTerm = t2s(term);

  // 🔹 建立搜尋詞組，包含簡體輸入 & 你/祢 互換版本
  let searchVariants = [simplifiedTerm];
  if (simplifiedTerm.includes('你')) {
    searchVariants.push(simplifiedTerm.replace(/你/g, '祢'));
  }
  if (simplifiedTerm.includes('祢')) {
    searchVariants.push(simplifiedTerm.replace(/祢/g, '你'));
  }

  // 🔹 過濾符合的歌曲（任一 variant 符合即可）
  const filtered = sortedHymnList.filter((hymn) =>
    searchVariants.some(variant => {
      const variantLower = variant.toLowerCase();
      return (
        hymn.编号.toString().includes(variant) ||
        hymn.歌名.toLowerCase().includes(variantLower) ||
        (hymn.繁體歌名 || '').toLowerCase().includes(variantLower) ||
        (hymn.英文歌名 || '').toLowerCase().includes(variantLower) ||
        hymn.原唱.toLowerCase().includes(variantLower) ||
        (hymn.繁體原唱 || '').toLowerCase().includes(variantLower) ||
        (hymn.字首 || '').toLowerCase().includes(variantLower)
      );
    })
  );

  setFilteredHymnList(filtered);
};


  const handleClearSearch = () => {
    setSearchTerm('');
    setFilteredHymnList([...sortedHymnList]);
  };

  const handleEnterKey = (e) => {
    if (e.key === 'Enter') handleSearch();
  };

  // ===== 排序功能 =====
  const shuffleArray = (arr) => {
    const a = [...arr];
    for (let i = a.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [a[i], a[j]] = [a[j], a[i]];
    }
    return a;
  };

  const requestSort = (field) => {
    let direction = 'asc';

    if (sortConfig.key === field) {
      if (field === '编号') {
        if (sortConfig.direction === 'asc') direction = 'desc';
        else if (sortConfig.direction === 'desc') direction = 'random';
        else direction = 'asc';
      } else {
        direction = sortConfig.direction === 'asc' ? 'desc' : 'asc';
      }
    } else {
      if (field === '编号') direction = 'desc';
      else direction = 'asc';
    }

    setSortConfig({ key: field, direction });

    let sorted;
    if (field === '编号') {
      if (direction === 'random') {
        sorted = shuffleArray(filteredHymnList);
      } else {
        sorted = [...filteredHymnList].sort((a, b) => compareBianHaoRaw(a.编号, b.编号, direction));
      }
    } else {
      sorted = [...filteredHymnList].sort((a, b) => {
        const av = (a[field] || '').toString();
        const bv = (b[field] || '').toString();
        return direction === 'asc'
          ? av.localeCompare(bv, 'zh-Hans-TW-u-kf-upper', { numeric: true, sensitivity: 'base' })
          : bv.localeCompare(av, 'zh-Hans-TW-u-kf-upper', { numeric: true, sensitivity: 'base' });
      });
    }
    setFilteredHymnList(sorted);
  };

  const getSortIcon = (field) => {
    if (sortConfig.key !== field) {
      return field === '编号' ? '🔀' : null;
    }
    if (sortConfig.direction === 'asc') return '▲';
    if (sortConfig.direction === 'desc') return '▼';
    if (sortConfig.direction === 'random') return '🔀';
    return null;
  };
  // =====================

  return (
    <div className="custom-playlist-editor"
      style={{ display: 'flex', maxWidth: '200vh', width: '90vw', height: '90vh', alignItems: 'flex-start', justifyContent: 'center', flexDirection: 'row', position: 'relative', padding: '10px', paddingTop: '30px', gap: '10px' }}
    >
      {/* 右上角關閉按鈕 */}
      <div
        style={{
          position: 'absolute', top: '2px', right: '8px', fontSize: '20px',
          cursor: 'pointer', padding: '4px 8px', backgroundColor: '#f0f0f0',
          borderRadius: '5px', width: 'auto', height: 'auto',
          display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}
        onClick={() => setIsCustomPlaylistOpen(false)}
      >
        X
      </div>

      {/* 左側操作區 */}
      <div style={{ paddingLeft: '10px', display: 'flex', minWidth: '35%', maxWidth: '45%', flexDirection: 'column', fontSize: '100%', overflowY: 'auto', maxHeight: 'calc(100vh - 40px)', paddingRight: '10px', paddingTop: '5px' }}>
        {/* ======== 語言模式選擇 ======== */}
        <div style={{
          marginBottom: '10px',
          display: 'flex',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '10px',
          padding: '8px 10px',
          border: '1px solid #ccc',
          borderRadius: '6px',
          backgroundColor: '#f5f5f5'
        }}>
          <span style={{ fontWeight: 'bold', fontSize: '14px', whiteSpace: 'nowrap' }}>
            {displayLanguage === '简体' ? '语言模式:' : displayLanguage === '繁體' ? '語言模式:' : 'Language:'}
          </span>
          {['繁體', '简体', 'English'].map((lang) => (
            <label
              key={lang}
              style={{ display: 'flex', alignItems: 'center', gap: '4px', cursor: 'pointer', fontSize: '14px', fontWeight: displayLanguage === lang ? 'bold' : 'normal' }}
              onClick={() => handleLanguageSelect(lang)}
            >
              <input
                type="radio"
                name="displayLanguageMode"
                checked={displayLanguage === lang}
                onChange={() => handleLanguageSelect(lang)}
                style={{ cursor: 'pointer' }}
              />
              {lang}
            </label>
          ))}
        </div>

        <h3 style={{ marginTop: '0px', marginBottom: "4px", fontSize: '18px' }}>{displayLanguage === '简体' ? '自选歌单(可更改下面歌单名称.先选歌单名称,再勾选右侧歌曲)' : displayLanguage === '繁體' ? '自選歌單(可更改下面歌單名稱.先選歌單名稱,再勾選右側歌曲)' : 'Custom Playlist(Edit playlist name below. Select name, then choose songs.)'}</h3>
        {customPlaylistNames.map((name, index) => (
          <div key={index} style={{ marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'center' }}>
            <input type="radio" name="customPlaylist" checked={index === selectedCustomPlaylistIndex} onChange={() => handleCustomPlaylistSelection(index)} style={{ cursor: 'pointer' }} />
            <input type="text" value={name} onChange={(e) => handleCustomPlaylistNameChange(e, index)} style={{ flex: '1', minWidth: '100px', maxWidth: '140px', padding: '5px' }} />
            <button
              onClick={() => {
                handleCustomPlaylistSelection(index);  // 🔹 先選中該歌單
                setClearConfirmIndex(index);           // 🔹 再顯示確認對話框
              }}
              title={getClearButtonTitle(index)}
              style={{
                padding: '6px 12px',
                backgroundColor: '#ff6b6b',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '12px',
                fontWeight: 'bold',
                minWidth: '55px',
                whiteSpace: 'nowrap'
              }}
            >
              {displayLanguage === '简体' ? '清除' : displayLanguage === '繁體' ? '清除' : 'Clear'}
            </button>
            
            {/* 確認清除對話框 */}
            {clearConfirmIndex === index && (
              <div style={{
                position: 'fixed',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                backgroundColor: 'white',
                border: '2px solid #333',
                borderRadius: '8px',
                padding: '20px',
                zIndex: 1000,
                boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                minWidth: '300px'
              }}>
                <p style={{ marginBottom: '15px', fontWeight: 'bold' }}>
                  {displayLanguage === '简体'
                    ? `确定要清除自选歌单${index + 1}的所有歌曲吗？`
                    : displayLanguage === '繁體'
                    ? `確定要清除自選歌單${index + 1}的所有歌曲嗎？`
                    : `Are you sure you want to clear all songs in Custom Playlist ${index + 1}?`}
                </p>
                <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
                  <button
                    onClick={() => setClearConfirmIndex(null)}
                    style={{
                      padding: '8px 16px',
                      backgroundColor: '#95e1d3',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      fontWeight: 'bold'
                    }}
                  >
                    {displayLanguage === '简体' ? '取消' : displayLanguage === '繁體' ? '取消' : 'Cancel'}
                  </button>
                  <button
                    onClick={() => handleClearPlaylist(index)}
                    style={{
                      padding: '8px 16px',
                      backgroundColor: '#ff6b6b',
                      color: 'white',
                      border: 'none',
                      borderRadius: '4px',
                      cursor: 'pointer',
                      fontWeight: 'bold'
                    }}
                  >
                    {displayLanguage === '简体' ? '确定清除' : displayLanguage === '繁體' ? '確定清除' : 'Confirm Clear'}
                  </button>
                </div>
              </div>
            )}
          </div>
        ))}


      {/* ======== 翻唱歌曲模式選擇 ======== */}
      <div style={{ marginBottom: '12px', marginTop: '8px', padding: '12px', border: '2px solid #4CAF50', borderRadius: '8px', backgroundColor: '#f9f9f9' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '10px' }}>
          <span style={{ fontWeight: 'bold', fontSize: '16px', color: '#333' }}>
            {displayLanguage === '简体'
              ? '翻唱歌曲模式'
              : displayLanguage === '繁體'
              ? '翻唱歌曲模式'
              : 'Cover Song Mode'}
          </span>
          <button
            onClick={() => {
              const msg = displayLanguage === '简体'
                ? `说明:
1. 请在右侧清单YouTube链结栏位输入该行歌名的自录歌曲链结
2. YouTube歌曲链结格式: https://www.youtube.com/watch?v=g0UJua1RTHY  保存之后会储存成 g0UJua1RTHY
3. VV音乐歌曲链结格式: 利用本系统录音功能,到VV音乐平台复制链结,格式 https://b.51vv2.com/wx/zp/130731684?shareUserId=935006014 ,播放VV音乐歌曲时播放器是静音,请点击右下角喇叭图案打开声音.`
                : displayLanguage === '繁體'
                ? `說明:
1. 請在右側清單YouTube鏈結欄位輸入該行歌名的自錄歌曲鏈結
2. YouTube歌曲鏈結格式: https://www.youtube.com/watch?v=g0UJua1RTHY  保存之後會儲存成 g0UJua1RTHY
3. VV音樂歌曲鏈結格式: 利用本系統錄音功能,到VV音樂平台複製鏈結,格式 https://b.51vv2.com/wx/zp/130731684?shareUserId=935006014 ,播放VV音樂歌曲時播放器是靜音,請點擊右下角喇叭圖案打開聲音.`
                : `Instructions:
1. Enter your self-recorded song link in the YouTube link column on the right list
2. YouTube link format: https://www.youtube.com/watch?v=g0UJua1RTHY  After saving it will be stored as g0UJua1RTHY
3. VV Music link format: Use the recording function in this system, copy the link from VV Music platform, format: https://b.51vv2.com/wx/zp/130731684?shareUserId=935006014  VV Music player is muted by default, click the speaker icon at bottom right to enable sound.`;
              alert(msg);
            }}
            style={{
              padding: '2px 8px', fontSize: '12px', fontWeight: 'bold',
              backgroundColor: '#FF9800', color: 'white', border: 'none',
              borderRadius: '4px', cursor: 'pointer'
            }}
          >
            {displayLanguage === '简体' ? '说明' : displayLanguage === '繁體' ? '說明' : 'Help'}
          </button>
        </div>
        
        {/* 模式1: 模式1: 只用自己輸入的YouTube歌曲鏈結或VV音樂歌曲鏈結 */}
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px', padding: '6px', backgroundColor: coverSongMode === 1 ? '#e8f5e9' : 'transparent', borderRadius: '4px' }}>
          <input 
            type="radio" 
            name="coverSongMode" 
            checked={coverSongMode === 1} 
            onChange={() => handleCoverModeChange(1)}
            style={{ cursor: 'pointer', marginRight: '8px' }}
          />
          <label style={{ cursor: 'pointer', fontSize: '14px' }} onClick={() => handleCoverModeChange(1)}>
            {displayLanguage === '简体'
              ? '1. 只用自己输入的YouTube歌曲链结或VV音乐歌曲链结'
              : displayLanguage === '繁體'
              ? '1. 只用自己輸入的YouTube歌曲鏈結或VV音樂歌曲鏈結'
              : '1. Use only YouTube song links or VV Music song links'}
          </label>
        </div>
        
        {/* 模式2: 優先使用自己輸入的YouTube鏈結或VV音樂歌曲鏈結 */}
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '8px', padding: '6px', backgroundColor: coverSongMode === 2 ? '#e8f5e9' : 'transparent', borderRadius: '4px' }}>
          <input 
            type="radio" 
            name="coverSongMode" 
            checked={coverSongMode === 2} 
            onChange={() => handleCoverModeChange(2)}
            style={{ cursor: 'pointer', marginRight: '8px' }}
          />
          <label style={{ cursor: 'pointer', fontSize: '14px' }} onClick={() => handleCoverModeChange(2)}>
            {displayLanguage === '简体'
              ? '2. 优先使用自己输入的YouTube链结或VV音乐歌曲链结（默认）'
              : displayLanguage === '繁體'
              ? '2. 優先使用自己輸入的YouTube鏈結或VV音樂歌曲鏈結（預設）'
              : '2. Prioritize using YouTube links or VV Music song links (Default)'}
          </label>
        </div>
        
        {/* 模式3: 使用系統內建翻唱歌曲 */}
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: '0px', padding: '6px', backgroundColor: coverSongMode === 3 ? '#e8f5e9' : 'transparent', borderRadius: '4px' }}>
          <input 
            type="radio" 
            name="coverSongMode" 
            checked={coverSongMode === 3} 
            onChange={() => handleCoverModeChange(3)}
            style={{ cursor: 'pointer', marginRight: '8px' }}
          />
          <label style={{ cursor: 'pointer', fontSize: '14px' }} onClick={() => handleCoverModeChange(3)}>
            {displayLanguage === '简体'
              ? '3. 使用系统内建翻唱歌曲'
              : displayLanguage === '繁體'
              ? '3. 使用系統內建翻唱歌曲'
              : '3. Use system built-in cover songs'}
          </label>
        </div>
      </div>


      {/* ======== YouTube播放清單1~5 設定區 ======== */}
      <div style={{ marginBottom: '12px', marginTop: '8px' }}>
        <div style={{ fontWeight: 'bold', marginBottom: '8px', marginTop: '0px' }}>
          {displayLanguage === '简体'
            ? 'YouTube播放清单1~5'
            : displayLanguage === '繁體'
            ? 'YouTube播放清單1~5'
            : 'YouTube Playlists 1–5'}
        </div>

        <div style={{ fontSize: '12px', marginBottom: "4px" }}>
          {displayLanguage === '简体'
            ? '格式: https://www.youtube.com/playlist?list=PL4GpUQOn9sZDLZZx6qWKPZ5aM_rjcQskn'
            : displayLanguage === '繁體'
            ? '格式: https://www.youtube.com/playlist?list=PL4GpUQOn9sZDLZZx6qWKPZ5aM_rjcQskn'
            : 'Format: https://www.youtube.com/playlist?list=PL4GpUQOn9sZDLZZx6qWKPZ5aM_rjcQskn'}
        </div>

        <input
          type="text"
          value={youtubePlaylists[0]}
          onChange={(e) => {
            const v = [...youtubePlaylists];
            v[0] = e.target.value;
            setYoutubePlaylists(v);
          }}
          placeholder={displayLanguage === '简体' ? 'YouTube播放清单1' : displayLanguage === '繁體' ? 'YouTube播放清單1' : 'YouTube Playlist 1'}
          style={{ width: '100%', marginBottom: '4px' }}
        />

        <input
          type="text"
          value={youtubePlaylists[1]}
          onChange={(e) => {
            const v = [...youtubePlaylists];
            v[1] = e.target.value;
            setYoutubePlaylists(v);
          }}
          placeholder={displayLanguage === '简体' ? 'YouTube播放清单2' : displayLanguage === '繁體' ? 'YouTube播放清單2' : 'YouTube Playlist 2'}
          style={{ width: '100%', marginBottom: "4px" }}
        />

        <input
          type="text"
          value={youtubePlaylists[2]}
          onChange={(e) => {
            const v = [...youtubePlaylists];
            v[2] = e.target.value;
            setYoutubePlaylists(v);
          }}
          placeholder={displayLanguage === '简体' ? 'YouTube播放清单3' : displayLanguage === '繁體' ? 'YouTube播放清單3' : 'YouTube Playlist 3'}
          style={{ width: '100%', marginBottom: "4px" }}
        />

        <input
          type="text"
          value={youtubePlaylists[3]}
          onChange={(e) => {
            const v = [...youtubePlaylists];
            v[3] = e.target.value;
            setYoutubePlaylists(v);
          }}
          placeholder={displayLanguage === '简体' ? 'YouTube播放清单4' : displayLanguage === '繁體' ? 'YouTube播放清單4' : 'YouTube Playlist 4'}
          style={{ width: '100%', marginBottom: "4px" }}
        />

        <input
          type="text"
          value={youtubePlaylists[4]}
          onChange={(e) => {
            const v = [...youtubePlaylists];
            v[4] = e.target.value;
            setYoutubePlaylists(v);
          }}
          placeholder={displayLanguage === '简体' ? 'YouTube播放清单5' : displayLanguage === '繁體' ? 'YouTube播放清單5' : 'YouTube Playlist 5'}
          style={{ width: '100%', marginBottom: "4px" }}
        />
      </div>



        <div style={{ display: 'flex', gap: '10px', marginTop: '12px', marginBottom: '8px' }}>
          <button onClick={handleSaveCustomPlaylist} style={{ flex: 1, padding: '12px', height: 'auto', fontSize: '16px', fontWeight: 'bold', backgroundColor: '#4CAF50', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>
            {displayLanguage === '简体' ? '保存' : displayLanguage === '繁體' ? '保存' : 'Save'}
          </button>
          <button onClick={() => setIsCustomPlaylistOpen(false)} style={{ flex: 1, padding: '12px', height: 'auto', fontSize: '16px', fontWeight: 'bold', backgroundColor: '#2196F3', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>
            {displayLanguage === '简体' ? '退出编辑' : displayLanguage === '繁體' ? '退出編輯' : 'Exit Editing'}
          </button>
        </div>
        {/* ✅ 訊息框固定佔位，不論有無訊息都保留空間 */}
        <div style={{ marginTop: '6px', minHeight: '36px', padding: '8px', backgroundColor: message ? '#e8f5e9' : '#f5f5f5', color: message ? '#2e7d32' : 'transparent', borderRadius: '4px', textAlign: 'center', fontWeight: 'bold', fontSize: '14px', border: '1px solid ' + (message ? '#a5d6a7' : '#e0e0e0'), transition: 'background-color 0.3s' }}>
          {message || '\u00A0'}
        </div>

        {/* ======== 創建自錄詩歌影片 ======== */}

      </div>

      {/* 右側歌曲表格 */}
      <div style={{ flex: '1', display: 'flex', flexDirection: 'column', marginTop: '0px', overflowY: 'hidden', maxHeight: 'calc(100vh - 50px)' }}>
        {/* 搜尋區 */}
        <div style={{ display: 'flex', marginBottom: '5px', gap: '5px' }}>
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onKeyDown={handleEnterKey}
            placeholder={
              displayLanguage === '简体'
                ? '搜索歌曲'
                : displayLanguage === '繁體'
                ? '搜尋歌曲'
                : 'Search songs'
            }
            style={{ width: '50%', padding: '4px 5px' }}
          />

          <button onClick={handleSearch} style={{ marginLeft: '3px', padding: '4px 8px' }}>{displayLanguage === '简体' ? '搜索' : displayLanguage === '繁體' ? '搜尋' : 'Search'}</button>
          <button onClick={handleClearSearch} style={{ marginLeft: '3px', padding: '4px 8px' }}>{displayLanguage === '简体' ? '清除' : displayLanguage === '繁體' ? '清除' : 'Clear'}</button>
        </div>

        {/* 歌曲清單 */}
        <div style={{ overflowY: 'auto', flex: '1', border: '1px solid black', borderRadius: '5px', maxHeight: 'calc(100vh - 120px)' }}>
          <table>
            <thead style={{ backgroundColor: 'SpringGreen', position: 'sticky', top: 0 }}>
              <tr>
                <th>{displayLanguage === '简体' ? '选' : displayLanguage === '繁體' ? '選' : 'Sel'}</th>

                {/* 編號 + 排序符號同一行 */}
                <th onClick={() => requestSort('编号')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                  <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                    {displayLanguage === '简体' ? '编号' : displayLanguage === '繁體' ? '編號' : 'NO'}
                    <span style={{ marginLeft: 4 }}>{getSortIcon('编号')}</span>
                  </span>
                </th>

                <th onClick={() => requestSort('歌名')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                  {displayLanguage === '简体' ? '歌名' : displayLanguage === '繁體' ? '歌名' : 'Song title'}
                  <span style={{ marginLeft: 4 }}>{getSortIcon('歌名')}</span>
                </th>

                <th onClick={() => requestSort('原唱')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                  {displayLanguage === '简体' ? '原唱' : displayLanguage === '繁體' ? '原唱' : 'Singer'}
                  <span style={{ marginLeft: 4 }}>{getSortIcon('原唱')}</span>
                </th>

                <th onClick={() => requestSort('英文歌名')} style={{ cursor: 'pointer', whiteSpace: 'nowrap' }}>
                  {displayLanguage === '简体' ? '英文歌名' : displayLanguage === '繁體' ? '英文歌名' : 'English title'}
                  <span style={{ marginLeft: 4 }}>{getSortIcon('英文歌名')}</span>
                </th>
                
                {/* ✅ 只在翻唱模式且模式1或2時顯示YouTube連結輸入欄 */}
                {isInCoverMode && (coverSongMode === 1 || coverSongMode === 2) && (
                  <th style={{ whiteSpace: 'nowrap' }}>
                    {displayLanguage === '简体' ? 'YouTube链结' : displayLanguage === '繁體' ? 'YouTube鏈結' : 'YouTube Link'}
                  </th>
                )}
              </tr>
            </thead>
            <tbody>
              {filteredHymnList.map((hymn, index) => {
                // ✅ 計算背景顏色：只在歌單模式且當前歌單包含此歌曲時顯示 lightblue
                const isInCurrentPlaylist = selectedCustomPlaylistIndex >= 0 && 
                                           customPlaylist[selectedCustomPlaylistIndex] && 
                                           customPlaylist[selectedCustomPlaylistIndex].includes(hymn.编号);
                const bgColor = isInCurrentPlaylist ? 'lightblue' : 'plum';
                
                return (
                  <tr key={index} style={{ backgroundColor: bgColor }}>
                    <td>
                      {/* ✅ 在翻唱模式時 disable 複選框 */}
                      <input 
                        type="checkbox" 
                        checked={checkedSongs[hymn.编号] || false} 
                        onChange={() => handleToggleSong(hymn.编号)} 
                        disabled={isInCoverMode}
                      />
                    </td>
                    <td>{hymn.编号}</td>
                    <td>{displayLanguage === '繁體' ? hymn.繁體歌名 : hymn.歌名}</td>
                    <td>{displayLanguage === '繁體' ? hymn.繁體原唱 : hymn.原唱}</td>
                    <td>{hymn.英文歌名}</td>
                    
                    {/* ✅ 只在翻唱模式且模式1或2時顯示YouTube連結輸入框 */}
                    {isInCoverMode && (coverSongMode === 1 || coverSongMode === 2) && (
                      <td>
                        <input
                          type="text"
                          value={userCoverLinks[hymn.编号] || ''}
                          onChange={(e) => handleCoverLinkChange(hymn.编号, e.target.value)}
                          placeholder="YouTube URL or ID"
                          style={{ width: '150px', padding: '2px' }}
                        />
                      </td>
                    )}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default CustomPlaylistEditor;
